import script from "./GridCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./GridCanvas.vue?vue&type=script&setup=true&lang=js"

import "./GridCanvas.vue?vue&type=style&index=0&id=4e526bce&lang=css"

const __exports__ = script;

export default __exports__